export const getFileExtension = (fileName: string): string => {
  return fileName.split(".").pop() ?? "";
};

export const getFileNameWithoutExtension = (fileName: string): string => {
  return fileName.split(".")[0] ?? "";
};
